import { FDealType, FOfferType, isAvailable } from 'shared/common/packages/JsonQuery';

import { RoomTypeContainer } from '../../containers/filters/RoomTypeContainer';
import { IFilter } from '../../types/filters';

export const roomType: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Flat),
  component: RoomTypeContainer,
};
